import { BaseEntity } from "../../core";

export class PrecargaSinDenuncia extends BaseEntity {
  public precargaId: number;
  public fecha: Date;
  public fechaString: string;
  public hora: string;
  public conductor: string;
  public dominioAseg: string;
  public internoAseg: string;
  public lineaAseg: string;
  public codAseg: number;
  public denunciaAseguradoId: number;
  public pathPrecarga: string;
  public gestionada: boolean;
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/precargaSinDenuncia.ts